/**
 * Labstep
 *
 * @module components/ProtocolCondition/ProtocolConditionProtocolValueVariableSmartTable
 * @desc ProtocolValue Variable Grid
 */

import { ProtocolConditionSmartTableModal } from 'labstep-web/components/ProtocolCondition/SmartTable/Modal';
import { ProtocolConditionSmartTableCollapsibleCard } from 'labstep-web/components/ProtocolCondition/SmartTableCollapsibleCard';
import { ActionComponent } from 'labstep-web/core/Action/Component';
import { GridSmartTableProtocolConditionService } from 'labstep-web/grid/SmartTableProtocolCondition/services/grid-smart-table-protocol-condition.service';
import { useActiveGroup } from 'labstep-web/hooks/activeGroup';
import {
  ENTITY_VIEW_DEFAULT_PARAMETERS,
  EntityView,
} from 'labstep-web/models/entity-view.model';
import { ProtocolCondition } from 'labstep-web/models/protocol-condition.model';
import type React from 'react';
import type { ProtocolConditionProtocolValueVariableSmartTableProps } from './types';

export const ProtocolConditionProtocolValueVariableSmartTable: React.FC<
  ProtocolConditionProtocolValueVariableSmartTableProps
> = ({ protocol, defaultColIds, variableTemplate, name }) => {
  const activeGroup = useActiveGroup();

  const paramTemplate = variableTemplate?.resource_template;

  const previewEntityView = new EntityView({
    group: activeGroup.activeGroup!,
    context: 'smart_table',
    entity_name: ProtocolCondition.entityName,
    column_definition_ids: defaultColIds,
    parameters: ENTITY_VIEW_DEFAULT_PARAMETERS,
    name: name,
    ...(paramTemplate && { templateId: paramTemplate.guid }),
  });

  const fullEntityView = new EntityView({
    group: activeGroup.activeGroup!,
    context: 'smart_table',
    entity_name: ProtocolCondition.entityName,
    column_definition_ids:
      GridSmartTableProtocolConditionService.getDefaultVariableColIds(
        protocol,
      ),
    parameters: ENTITY_VIEW_DEFAULT_PARAMETERS,
    name: name,
    ...(paramTemplate && { templateId: paramTemplate.guid }),
  });

  return (
    <ProtocolConditionSmartTableCollapsibleCard
      entityView={previewEntityView}
      experimentOrProtocol={protocol}
      group={activeGroup.activeGroup!}
      initialExpandedState={true}
      disableHeader
      expandComponent={
        <ProtocolConditionSmartTableModal
          experimentOrProtocol={protocol}
          entityView={fullEntityView}
          viewComponent={({ toggleModal }) => (
            <ActionComponent
              type="icon"
              icon="external alternate"
              elementProps={{ color: 'blue' }}
              onClick={(e) => {
                e.stopPropagation();
                toggleModal();
              }}
            />
          )}
        />
      }
    />
  );
};
